import React, { useEffect, useMemo, useState } from "react";
import { CheckCircle2, CircleAlert, LockKeyhole } from "lucide-react";
import { formatDate, formatStatusLabel, toDateInputValue } from "../../pages/Projects/projects.helpers";
import { getArgentinaToday, getProjectCompletionReadiness } from "./projectCompletion";
import "./projectGantt.css";

function ProjectCompletionSection({ project, tasks = [], canManage, saving, onComplete }) {
  const readiness = useMemo(() => getProjectCompletionReadiness(tasks), [tasks]);
  const [completionDate, setCompletionDate] = useState(
    toDateInputValue(project?.actual_end_date) || getArgentinaToday(),
  );

  useEffect(() => {
    setCompletionDate(toDateInputValue(project?.actual_end_date) || getArgentinaToday());
  }, [project?.actual_end_date, project?.id]);

  const isClosed = project?.status === "cerrado";

  return (
    <section className={`projects-card project-completion-section${isClosed ? " is-closed" : ""}`}>
      <div className="projects-card-header projects-detail-section-header">
        <div>
          <h2>Fin de implementación</h2>
          <p>Revisá el plan de acción y registrá cuándo terminó la implementación.</p>
        </div>
        {isClosed ? <span className="project-completion-badge"><LockKeyhole size={14} /> Proyecto cerrado</span> : null}
      </div>

      {isClosed ? (
        <div className="project-completion-closed">
          <CheckCircle2 size={24} />
          <div><strong>Implementación finalizada</strong><span>Fecha real de finalización: {formatDate(project.actual_end_date)}</span></div>
        </div>
      ) : (
        <div className="project-completion-content">
          <div className="project-completion-checks">
            <div className={readiness.openTasks.length ? "has-warning" : "is-ready"}>
              {readiness.openTasks.length ? <CircleAlert size={18} /> : <CheckCircle2 size={18} />}
              <span><strong>Plan de acción</strong>{readiness.resolvedCount} de {readiness.totalCount} tarea(s) resueltas</span>
            </div>
            <div className={readiness.blockedTasks.length ? "has-warning" : "is-ready"}>
              {readiness.blockedTasks.length ? <CircleAlert size={18} /> : <CheckCircle2 size={18} />}
              <span><strong>Tareas bloqueadas</strong>{readiness.blockedTasks.length ? `${readiness.blockedTasks.length} pendiente(s) de resolver` : "Ninguna"}</span>
            </div>
          </div>

          {!readiness.ready ? (
            <p className="project-completion-guidance">Completá o cancelá las tareas abiertas y resolvé las bloqueadas antes de finalizar el proyecto.</p>
          ) : null}

          {canManage ? (
            <div className="project-completion-action">
              <label className="projects-field">
                <span>Fecha real de finalización</span>
                <input type="date" value={completionDate} onChange={(event) => setCompletionDate(event.target.value)} />
              </label>
              <button type="button" className="projects-btn projects-btn-primary" disabled={!readiness.ready || !completionDate || saving} onClick={() => onComplete(completionDate)}>
                {saving ? "Finalizando..." : "Finalizar proyecto"}
              </button>
            </div>
          ) : (
            <p className="project-completion-guidance">Estado actual: {formatStatusLabel(project?.status)}.</p>
          )}
        </div>
      )}
    </section>
  );
}

export default ProjectCompletionSection;
